import * as React from 'react';

import * as Icons from './components/Icons';
import Step from './components/Step';
import DownloadForm from './components/DownloadForm';
import UploadForm from './components/UploadForm';

class LinkCreateBulkExcel extends React.Component {
  render() {
    return (
      <div className="max-w-xl mx-auto my-16">
        <Step
          title="Always download current Excel template"
          index={1}
          Icon={<Icons.Download />}
        >
          <p className="mb-12">
            Make sure to download the template each time you would like to
            create new tracking links in Excel. This will ensure that you have
            the most recent data in your Excel file. In case of using a template
            that is out of date, errors for some tracking links might occur.
          </p>
          <DownloadForm />
        </Step>
        <Step
          title="Create tracking links in the Excel template"
          index={2}
          Icon={<Icons.Create />}
        >
          <p className="mb-4">
            For most columns you have the possibility to choose the appropirate
            value from a drop down menu. Be aware that each drop down displays
            all possible values. Please consider the content dependencies
            between columns while selecting e.g. topic and subtopic or placement
            type and placement number etc.
          </p>
          <p>
            The columns “Tracking link id”, “Tracking link” and “System
            notification” will be filled automatically by the system, please
            leave them empty.
          </p>
        </Step>
        <Step
          title="Upload filled out Excel template"
          index={3}
          Icon={<Icons.Upload />}
        >
          <p className="mb-4">
            Please select your Excel template for the upload.
          </p>
          <p className="mb-12">
            After clicking on "Upload file" the upload will start automatically.
            The upload result will not be displayed here. You will receive a
            confirmation mail including an overview of successful and
            unsuccessful tracking links. All successfully uploaded tracking
            links will be saved on the "Existing Links" startpage.
          </p>
          <UploadForm />
        </Step>
        <Step title="Confirmation mail" index={4} Icon={<Icons.Mail />}>
          <p>
            Attached to the confirmation mail you will find your Excel template.
            Each row will now contain the final tracking link ready for use. All
            incorrect tracking links are marked in red and have not been
            uploaded.
          </p>
        </Step>
        <Step title="In case of errors" index={5} Icon={<Icons.Error />}>
          <p className="mb-4">
            In case errors occurred for some tracking links you will find an
            error message in the very right column. The incorrect columns is
            marked in red.
          </p>
          <p className="mb-4">
            The most likely error is caused by not selecting matching elements
            (dependencies betweens columns). After correcting all errors plase
            upload the entire file again. All tracking links that have been
            successfully uploaded before will not be created again.
          </p>
          <p>Repeat steps 3 – 5 until all links were created successfully.</p>
        </Step>
      </div>
    );
  }
}

export default LinkCreateBulkExcel;



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulkExcel/LinkCreateBulkExcel.tsx